import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { TableDetailsSectionComponentProps } from './types';

export const TableDetailsGeneratedSection: FC<
  TableDetailsSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
